document.addEventListener("DOMContentLoaded", function () {
    if (typeof Swiper === 'undefined') {
        console.error("Swiper n'est pas chargé !");
        return;
    }

    var swiper = new Swiper('.swiper', {
        slidesPerView: 1.5,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        loop: false,
        grabCursor: true,
        draggable: true,
        breakpoints: {
            768: {
                slidesPerView: 3,
            }
        },
    });


  const menuDrawer = document.getElementById("Details-menu-drawer-container");
  const htmlElement = document.documentElement;

  // Vérifie si l'on est sur un écran mobile (par exemple, 768px ou moins)
  if (window.innerWidth <= 768) {
      menuDrawer.addEventListener("click", function(){
      htmlElement.classList.toggle("no-scroll");
    });
  };
});
